// extracted by mini-css-extract-plugin
export var active = "_2a-d";
export var blink = "_2a-e";
export var container = "_2a-5";
export var controls = "_2a-0";
export var controlsRight = "_2a-1";
export var fakeCursor = "_2a-c";
export var hidden = "_2a-b";
export var quillContainerSmall = "_2a-7";
export var quillEditor = "_2a-6";
export var quillEditorSmall = "_2a-8";
export var quillFormatButtons = "_2a-a";
export var quillToolbar = "_2a-9";
export var removePadding = "_2a-2";
export var state = "_2a-3";
export var stateTitle = "_2a-4";